<div>
  <div *ngIf="!fromCart && !alreadyAdded() && !focus" class="py-2 btn-add p-d-flex p-jc-center">
    <button pButton pRipple (click)="addProduct()" type="button" class="p-button-rounded" [style.background-color]="isAvailable ? styleConfig.backgroundColor : '#bcbcbc'"
    [style.color]="isAvailable ? styleConfig.color : 'white'" [disabled]="loading || _cartService.disabledButton">
      <span class="btn-text">{{this.buyButtonText}}</span><i class="pi pi-shopping-cart"></i>
    </button>
  </div>
  <div *ngIf="alreadyAdded() || focus" class="input-group">
    <div class="input-group-prepend">
      <button pButton pRipple class="p-button-rounded p-button-secondary p-button-text" type="button" (click)="minus()" [disabled]="loading || _cartService.disabledButton">
        <i [class]="measurementUnit.cartQuantity > 1 ? 'pi pi-minus' : 'pi pi-trash'"></i>
      </button>
    </div>
    <input type="text" inputmode="numeric" [(ngModel)]="measurementUnit.cartQuantity" class="input-number" [onlyNumber]="true" min="0"
    (focusout)="validateKey($event.target.value)" (focusin)="setFocus()" [disabled]="loading || _cartService.disabledButton">
    <div class="input-group-append">
      <button pButton pRipple class="p-button-rounded p-button-secondary p-button-text" type="button" (click)="plus()" [disabled]="loading || _cartService.disabledButton">
        <i class="pi pi-plus"></i></button>
    </div>
    <span class="input-number">{{ measurementUnit.measurementInitials }}</span>
  </div>
</div>